































































import { Component } from 'vue-property-decorator';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { IRole, IUser, UserSpecialType, UserStatus } from 'admiral-core';

import { Edit2Icon, MoreVerticalIcon, PlusIcon } from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';
import CreateUserModal from '@/views/pages/settings/agency/CreateUserModal.vue';
import { Util } from '@/utils/Util';
import { UserApi } from '@/services/UserApi';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';
import EditUserModal from '@/views/pages/settings/agency/EditUserModal.vue';

@Component({
  name: 'agency-users-settings',
  components: {
    EditUserModal,
    CreateUserModal,
    Avatar,
    MoreVerticalIcon,
    UserStatusBadge,
    Edit2Icon,
    PlusIcon,
  },
})
class AgencyUsersSettings extends mixins(BaseMixin) {
  selectedUser?: Partial<IUser> = {};
  allUsers: IUser[] = [];

  async mounted() {
    try {
      const response = await UserApi.getUsers({
        agency: this.agency,
        status: [UserStatus.PENDING, UserStatus.ACTIVE, UserStatus.DELETED],
      });
      this.allUsers = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  get agency() {
    return this.user.agency;
  }

  openEditModal(user: IUser) {
    this.selectedUser = user;
    // eslint-disable-next-line
    (this.$refs['edit-user-modal'] as any).$refs['edit-user'].show();
  }

  openCreateModal() {
    // eslint-disable-next-line
    (this.$refs['create-user-modal'] as any).$refs['create-user'].show();
  }

  async reload() {
    const response = await UserApi.getUsers({
      agency: this.agency,
      status: [UserStatus.PENDING, UserStatus.ACTIVE, UserStatus.DELETED],
    });
    this.allUsers = response.data;

    await this.$store.dispatch('DataModule/fetchUsers', {
      agency: this.user.agency,
    });
  }

  roleLabel(role: IRole) {
    return Util.formatUserRoleName(role);
  }

  typeLabel(type: UserSpecialType) {
    return Util.formatUserSpecialType(type);
  }
  printGroup(group?: string) {
    return group ? `(${group})` : '';
  }
}

export default AgencyUsersSettings;
